import React, { Component } from 'react';
import HeaderButtons from './HeaderButtons.jsx';

import {
    searchConfigurationSession,
    resetStateConfigSesionVista
} from '../actions/ConfiguracionSesionVista';

class Headers extends Component {

    constructor(props) {
        super(props);

        this.state = {
            searchUser: ""
        }
    }

    render() {
        return (
            <div className="row user-list bottom-separator-xxs">
                <div className="col-md-4">
                    <HeaderButtons
                        functions={this.props.functions}
                    />
                </div>
            </div>
        );
    }
};

export default Headers